import React, { ReactNode } from 'react'

import { DayPickerSingleProps } from 'react-day-picker'

import { useArcadeMigrationFeatureFlag } from '../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeDatePicker from './ArcadeDatePicker'
import { Copy } from './DatePickerCopy'
import MooncakeDatePicker from './MooncakeDatePicker'

type CustomProps = {
  copy?: Copy
  open?: boolean
  closeOnSelect?: boolean
  onClose?: () => void
  children?: (targetProps: { 'aria-haspopup': 'dialog' }) => ReactNode
}

export type DatePickerProps = CustomProps &
  Omit<
    DayPickerSingleProps,
    | 'captionLayout'
    | 'className'
    | 'classNames'
    | 'components'
    | 'formatters'
    | 'labels'
    | 'locale'
    | 'mode'
    | 'numberOfMonths'
    | 'styles'
  >

export const DatePicker = (props: DatePickerProps) => {
  const shouldUseArcadeDatePicker = useArcadeMigrationFeatureFlag('date-picker')

  if (shouldUseArcadeDatePicker) {
    return <ArcadeDatePicker {...props} />
  }

  return <MooncakeDatePicker {...props} />
}
